import { useEffect, useRef, useState } from "react";
import { calculateStatus, calculateTime, getWaveTop } from "../function/store";

const OrderProgress = ({ item }) => {
  const [remainingMin, setRemainingMin] = useState(() => calculateTime(item));
  const frameRef = useRef();
  const prevRef = useRef(remainingMin);

  useEffect(() => {
    const loop = () => {
      const current = calculateTime(item);
      if (current !== prevRef.current) {
        prevRef.current = current;
        setRemainingMin(current);
      }
      frameRef.current = requestAnimationFrame(loop);
    };

    frameRef.current = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(frameRef.current);
  }, [item]);

  return (
    <div className={`orderProgress ${calculateStatus(item)}`}>
      {[...Array(3)].map((_, i) => (
        <span key={i} style={{ top: `${getWaveTop(item)}px` }} className="wave" />
      ))}
      <div className="progressRemaining">
        <span>{remainingMin}분</span>
      </div>
    </div>
  );
};

export default OrderProgress;
